export const credentialsPermission = {
    credentialsCreate: "credentials.create",
    credentialsDelete: "credentials.delete",
    credentialsUpdate: "credentials.update",
    credentialsView: "credentials.view"
};
